export const ShareThisCMPS =
  "https://platform-api.sharethis.com/js/sharethis.js#property=6944b6ffe0891b98fd79a97c&product=sop"
